import { FileIdsValue, SelectMultipleValue } from '@kaizenplatform/hugot-entity';
import gql from 'graphql-tag';

import GraphQLClient, { GraphQLOperationFailed } from '../../adapter/GraphQLClient';
import { GetProjectChangeQuery, ProjectDetailsForShowFragment } from '../../generated/graphql';
import { jsonToDynamicSchemaValue } from '../../graphql/project';
import { ProjectForBrief } from './../../graphql/project';

export type ProjectChangeType = {
  updatedAt: any;
  latestVersion: {
    creativeBriefValues: Map<string, string | number | boolean | SelectMultipleValue | FileIdsValue | null>;
    assetCategoryValues: Map<string, string | number | boolean | SelectMultipleValue | FileIdsValue | null> | null;
  };
  beforeVersion: {
    creativeBriefValues: Map<string, string | number | boolean | SelectMultipleValue | FileIdsValue | null>;
    assetCategoryValues: Map<string, string | number | boolean | SelectMultipleValue | FileIdsValue | null> | null;
  };
};

class ProjectChangeWebApi {
  private readonly graphqlClient: GraphQLClient;

  constructor({ graphqlClient }: { graphqlClient: GraphQLClient }) {
    this.graphqlClient = graphqlClient;
  }

  public get = async (project: ProjectForBrief & ProjectDetailsForShowFragment): Promise<ProjectChangeType | null> => {
    try {
      const result = await this.graphqlClient.query(
        gql`
          query getProjectChange($projectId: ID!) {
            projectChange(projectId: $projectId) {
              updatedAt
              latestVersion {
                creativeBrief
                assetCategory
              }
              beforeVersion {
                creativeBrief
                assetCategory
              }
            }
          }
        `,
        { projectId: project.id },
      );
      if (result.projectChange) {
        const change = result.projectChange as NonNullable<GetProjectChangeQuery['projectChange']>;
        const res: ProjectChangeType = {
          updatedAt: change.updatedAt,
          latestVersion: {
            creativeBriefValues: jsonToDynamicSchemaValue(
              change.latestVersion.creativeBrief,
              project.creativeBriefDefinition,
            ).values,
            assetCategoryValues:
              change.latestVersion?.assetCategory && project.assetCategoryDefinition
                ? jsonToDynamicSchemaValue(change.latestVersion.assetCategory, project.assetCategoryDefinition).values
                : null,
          },
          beforeVersion: {
            creativeBriefValues: jsonToDynamicSchemaValue(
              change.beforeVersion.creativeBrief,
              project.creativeBriefDefinition,
            ).values,
            assetCategoryValues:
              change.beforeVersion?.assetCategory && project.assetCategoryDefinition
                ? jsonToDynamicSchemaValue(change.beforeVersion.assetCategory, project.assetCategoryDefinition).values
                : null,
          },
        };
        return res;
      } else {
        return null;
      }
    } catch (err) {
      if (err instanceof GraphQLOperationFailed) {
        throw err;
      }
      throw err;
    }
  };
}

export default ProjectChangeWebApi;
